'use strict';

module.exports = {
  src: 'about:blank',
  frameBorder: 0,
  allowtransparency: true,
  scrolling: 'no'
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/@braintree/iframer/lib/default-attributes.js
// module id = 1060
// module chunks = 0